<script setup lang="ts">
import {
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonMenuToggle,
  IonTitle,
  IonToolbar
} from '@ionic/vue';
import {emitter} from "@/router";
import {cogOutline} from "ionicons/icons";

const onResolveTest = () => {
  console.debug("Emitter: event-ResolveTest");
  emitter.emit('event-ResolveTest', {});
};

const onModoGrabacion = () => {
  console.debug("Emitter: event-ModoGrabacion");
  emitter.emit('event-ModoGrabacion', {});
};

const onEditQuestionInAdminPage = () => {
  const url = import.meta.env.VITE_BACKEND;

  const testId = document.getElementById('test-identificacion')?.dataset.testId;
  if (!testId) {
    console.error("Test Id no encontrado");
    return;
  }
  window.open(`${url}questions/${testId}/edit`, "_blank");
};

</script>

<template>
  <ion-menu side="end" menu-id="admin-test-menu" content-id="main-content" :swipe-gesture="false">
    <ion-header>
      <ion-toolbar>
        <ion-title>Utilidades</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="content-menu">
      <ion-list>
        <ion-menu-toggle menu="admin-test-menu">
          <ion-item button @click="onResolveTest">
            <ion-icon aria-hidden="true" slot="start" :icon="cogOutline"></ion-icon>
            <ion-label>Resolver test</ion-label>
          </ion-item>
          <ion-item button @click="onModoGrabacion">
            <ion-icon aria-hidden="true" slot="start" :icon="cogOutline"></ion-icon>
            <ion-label>Modo grabación</ion-label>
          </ion-item>
          <ion-item button @click="onEditQuestionInAdminPage">
            <ion-icon aria-hidden="true" slot="start" :icon="cogOutline"></ion-icon>
            <ion-label>Editar pregunta</ion-label>
          </ion-item>
        </ion-menu-toggle>
      </ion-list>
    </ion-content>
  </ion-menu>
</template>

<style scoped>

.content-menu {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}


</style>